module.exports = __webpack_public_path__ + "static/img/login3.ff9ffec5.png";